/**
 * Construct Vuex 'enterprise' module
 *
 * @param {*} services Services object for API access
 * @return {*}
 */
export default function(services) {
  return {
    namespaced: true,
    state: {
      operations: [],
      requiresUpdate: true,
      regions: [],
      regionsRequireUpdate: true
    },
    mutations: {
      operations(state, operations) {
        state.operations = operations;
      },
      requiresUpdate(state, requiresUpdate) {
        state.requiresUpdate = requiresUpdate;
      },
      regions(state, regions) {
        state.regions = regions;
      },
      regionsRequireUpdate(state, requiresUpdate) {
        state.regionsRequireUpdate = requiresUpdate;
      }
    },
    actions: {
      initialize(context, forceUpdate) {
        if (context.state.requiresUpdate || forceUpdate) {
          context.commit('requiresUpdate', false);
          if ('enterprise' in context.rootState.auth.user.scopes) {
            return services.enterprise.get('/operations', {
              params: {
                excludeBase: true
              }
            }).then((response) => {
              context.commit('operations', response.data.data);
            });
          } else {
            context.commit('operations', []);
          }
        }
      },
      initializeRegions(context, forceUpdate) {
        if (context.state.regionsRequireUpdate || forceUpdate) {
          context.commit('regionsRequireUpdate', false);
          if ('enterprise' in context.rootState.auth.user.scopes) {
            return services.enterprise.get('/regions')
              .then((response) => {
                context.commit('regions', response.data.data);
              });
          } else {
            context.commit('[]');
          }
        }
      }
    }
  };
}
